import Table from './Table'
import simpleTable from './simpleTable'
const wonderLab = require('./tables/wonderlab.json')
const theSun = require('./tables/theSun.json')
const hubble3d = require('./tables/hubble3d.json')
const artPassCheckbox = '<div class="artPassCheckbox"><input type="checkbox" id="artPassCheckbox" name="artPassCheckbox"><label for="artPassCheckbox">I have an Art Pass</label></div>'

function familyDiscountMessage (message) {
  let familyDiscountHtml = `<div id="familyDiscountMessage">
  <h4>Family Discounts</h4>
  <p>A family discount is automatically applied to transactions including at least one child, and up to two adult tickets, for all applicable activities</p>
  <p>If you are booking for more than one family group, you will need to book each group in a separate transaction to receive a discount for each family</p>
  </div>`

  if (typeof message === 'string') {
    familyDiscountHtml = `<div id="familyDiscountMessage">${message}</div>`
  }
  if ($('#familyDiscountMessage').length === 0) {
    $('.tn-ticket-selector__pricetype-selector').before(familyDiscountHtml)
  }
}

// Event listener for dynamically generated checkbox

$(document).on('change', '#artPassCheckbox[type=checkbox]', function (e) {
  if ($(this).is(':checked')) {
    $('#c-custom-table').addClass('art-pass--enabled')
    $('#c-custom-table').removeClass('art-pass--disabled')
  } else {
    $('#c-custom-table').addClass('art-pass--disabled')
    $('#c-custom-table').removeClass('art-pass--enabled')
  }
})

const $body = $('body')

let pricingDataCache = {}

export default class PricingTable {
  constructor (zoneId, isTimedEntry = true) {
    pricingDataCache = {}

    this._zoneId = zoneId
    this.ticketSelection = {}

    const isWonderlab = $body.hasClass('143242')
    const isTheSun = $body.hasClass('209500')
    const isHubble3D = $body.hasClass('209499')

    this.userOverrides = Table.fromElement('#ticketSettings')
    if (this.userOverrides.settingsElementExists === false) {
      // Initiate custom configs
      if (isWonderlab) {
        this.userOverrides = new Table(wonderLab)
      } else if (isTheSun) {
        this.userOverrides = new Table(theSun)
      } else if (isHubble3D) {
        this.userOverrides = new Table(hubble3d)
      } else {
        simpleTable(this._zoneId)
        return // exit with basic table generated
      }
    }

    // If not timed entry
    // if (isTimedEntry === false) {
    //   simpleTable(this._zoneId, this.userOverrides)
    //   return
    // }

    if (Object.keys(pricingDataCache).length === 0) {
      if (this.userOverrides.settingsElementExists) {
        pricingDataCache = this.generatePriceJsonFromUserConfig(this.userOverrides)
        $('#tn-add-to-cart-button').prop('disabled', true)
      }
    }

    const fieldSet = $('#c-custom-table')
    let htmlToInsert = ''

    if (this.userOverrides.settingsElementExists) {
      if (this.userOverrides.showFamilyDiscount) {
        familyDiscountMessage(this.userOverrides.showFamilyDiscount)
      }

      htmlToInsert = this.customPricingTable()
    }

    if (fieldSet.length > 0) {
      fieldSet.html(htmlToInsert)
    } else {
      $('.tn-ticket-selector__pricetype-container').addClass('hidden')
      $('.tn-ticket-selector__controls-container').append(`<fieldset id="c-custom-table"><legend class="sr-only">Available Prices</legend>${htmlToInsert}</fieldset>`)
    }

    // Register listeners after dom appended
    this.childTicketOnClickListener()
    this.registerOnSelectListener()
  }

  childTicketOnClickListener () {
    $('.c-pricing-table__child select').on('change', function () {
      if (this.value > 0) {
        $('.c-pricing-table--individual').addClass('c-pricing-table--fd-applied')
      } else {
        $('.c-pricing-table--individual').removeClass('c-pricing-table--fd-applied')
      }
    })
  }

  /**
   * Generate options dropdown based on custom settings or fallback to default
   * @param {number} ticketType
   */
  _generateOptions (ticketType) {
    const ticket = this.userOverrides.ticket(ticketType)
    let optionsString = ''

    for (let i = 0; i <= ticket.dropdown; i++) {
      optionsString += `<option>${i}</option>`
    }

    return optionsString
  }

  selectBox (priceType, ticketType) {
    if (!priceType) {
      return ''
    }
    let selectBox = `<select class="form-control tn-ticket-selector__pricetype-select c-table__ticket-select" data-ticket-type="${ticketType}" data-zone-id="${this._zoneId}" data-pricetype-id="${priceType}" id='zone-${this._zoneId}-select-pricetype-${priceType}'>`

    selectBox += this._generateOptions(ticketType)
    selectBox += `</select>`
    return selectBox
  }

  customPricingTable () {
    //hide soldout zones
    $('.tn-ticket-selector__sold-out-section').hide();
    
    const config = this.userOverrides
    const tickets = config.tickets()

    let table = '<table class="c-pricing-table c-pricing-table--individual">'
    table += `<thead>
        <th><span class="c-pricing-table__title">${config.title}</span></th>`

    config.headers().forEach(h => {
      table += `<th>${h.label} <span class="c-pricing-table__subtext">${h.description}</span></th>`
    })

    table += `</thead>`
    tickets.forEach((ticket, idx) => {

      var discountedPrice 
      if (idx === 0 && config.hasFamilyDiscount) {
        table += `<tr><td>Family discount<span class="c-pricing-table__subtext">3-5 visitors including up to 2 adults. Your discount will be added when you add tickets to your basket</span></td>`        
            config.headers().forEach(h => {
            if (Number.isInteger(parseInt(h.familyDiscountAmount.substr(-1))))
              {
                table += '<td>' + h.familyDiscountAmount + ' off per ticket</td>'
              }
              else
              {
                table += '<td>' + h.familyDiscountAmount + '</td>'
              }
                  
          })
        table +=  `</tr>`
    
        }

//Check if the row will not have any price types first and skip if it does
  var priceTypeCount = 0;
  var withoutPriceType = 0;
  var ticketDesc = "";
   
  ticket.tablePriceTypes().forEach((row) => {
      priceTypeCount += 1;

      if (this.getPriceFromCache(row.id) == "")
      {
          withoutPriceType += 1;
      }
   })

if (!(priceTypeCount == withoutPriceType))
{

ticketDesc = ticket.description  
if (ticket.type == "unicredadult" || ticket.type =="unicredchild")
{
  ticketDesc = ticket.description + " (see <a href='https://www.sciencemuseum.org.uk/universal-credit-ticket-discounts'>eligibility details</a>)"
}  
      
      table += `<tr class="c-pricing-table__${ticket.type}">
          <td>${ticket.label} <span class="c-pricing-table__subtext">${ticketDesc}</span></td>
         `
      ticket.tablePriceTypes().forEach((row) => {
        table += `<td><div class="c-price c-price--regular">${this.getPriceFromCache(row.id)} ${this.selectBox(row.id, ticket.type)}</div>`
        const artPass = ticket.matchingArtPass(row.type)
        if (artPass) {
          table += `<div class="c-price c-price--art-pass">${this.getPriceFromCache(artPass.id)} ${this.selectBox(artPass.id, ticket.type)}</div>`
        }
        table += '</td>'
      })
      table += '</tr>'
}
    table +=  `</tr>`
      
    })
    table += '</table>'

    if (config.showArtPassCheckbox) {
      table += artPassCheckbox
    }

    table += '<div class="c-errors"></div>'

    return table
  }
  generatePriceJsonFromUserConfig (userConfig) {
    const priceJson = {}

    const tickets = userConfig.tickets()
    tickets.forEach(t => {
      t.priceTypes().forEach(price => {
        priceJson[price.id] = this.getPrice(price.id)
      })
    })
    return priceJson
  }

  generatePriceJson (prices) {
    const priceJson = {}

    prices.forEach(category => {
      category.priceType.forEach(type => {
        priceJson[type] = this.getPrice(type)
      })
    })

    return priceJson
  }

  getPrice (priceType) {

    if (!priceType || !this._zoneId)  {
      // If the pricetypes does not have a zoneID or a priceType ID, return empty string
      return ''
    }

    const price = document.querySelector(`#tn-fixed-amount-input-${this._zoneId}-${priceType}`);
    let priceVal = ''

    if (price) {
      // If the price exists, then grab the price value from the input
      priceVal = price.value.replace('£', '');
    } else {
      // otherwise return an empty string
      return ''
    }
    
    if (priceVal == null) {
      // If the price value is null, return an empty string
      return ''
    } else {
      // otherwise return a value [(17.00) for example]
      return priceVal;
    }

  }

  registerOnSelectListener () {
    const self = this
    $('table.c-pricing-table select.c-table__ticket-select').change(function (e) {
      const event = $(this)
      const ticketType = event.data('ticket-type')
      const priceType = event.data('pricetype-id')

      if (ticketType) {
        if (!self.ticketSelection[ticketType]) {
          self.ticketSelection[ticketType] = {}
        }

        self.ticketSelection[ticketType][priceType] = parseInt(event.val(), 10)
      }
      self.validateBasket()
    })
  }

  _totalNumberOfTypeInBasket (ticketType) {
    const tickets = this.ticketSelection[ticketType]
    if (!tickets) {
      return 0
    }
    return Object.keys(tickets).reduce((acc, ticket) => {
      acc += tickets[ticket]
      return acc
    }, 0)
  }

  /**
   * Perform basket validations on ratios and numbers of tickets.
   * Display appropriate errors and warnings if ratios are not met.
   */
  validateBasket () {
    const tickets = this.userOverrides.tickets()
    const numberOfTickets = {}
    const errors = []
    const ticketsWithRatios = []

    tickets.forEach(t => {
      if (t.hasRatio) {
        ticketsWithRatios.push(t)
      }
      if (!numberOfTickets[t.type]) {
        numberOfTickets[t.type] = this._totalNumberOfTypeInBasket(t.type)
      }
      if (numberOfTickets[t.type] < t.min) {
        errors.push(`You cannot book fewer than ${t.min} ${t.label} tickets. You currently have ${numberOfTickets[t.type]}`)
      }
      if (numberOfTickets[t.type] > t.max) {
        errors.push(`You cannot book more than ${t.max} ${t.label} tickets at a time. You currently have ${numberOfTickets[t.type]}`)
      }
    })

    // Validate ratios
    ticketsWithRatios.forEach(t => {
      t.ratios().forEach(r => {
// Added 01/05/2025 AJF - stops ratios being validated if the subject of the ratio isn't in the basket
        if (numberOfTickets[t.type] > 0)
        {
        
        if (numberOfTickets[r.type] / (numberOfTickets[t.type] === 0 ? 1 : numberOfTickets[t.type]) < (r.min)) {
          errors.push(`You must have at least ${r.min} ${this.userOverrides.ticket(r.type).type} ticket(s) for each ${t.label} ticket in a single booking.`)
        }
        if (numberOfTickets[r.type] / (numberOfTickets[t.type] === 0 ? 1 : numberOfTickets[t.type]) > (r.max)) {
          errors.push(`You cannot have more than ${r.max} ${this.userOverrides.ticket(r.type).type} ticket(s) for each ${t.label} ticket in a single booking.`)
        }
        }
      })
    })

    if (errors.length === 0) {
      $('#tn-add-to-cart-button').prop('disabled', false)
    } else {
      // A hack to get around the base tnew JS also controlling the checkout button state
      setTimeout(() => { $('#tn-add-to-cart-button').prop('disabled', true) }, 10)
    }

    this.displayErrors(errors)
  }

  /**
   *
   * @param {Array<string>} errors
   */
  displayErrors (errors) {
    if (errors.length === 0) {
      $('.c-errors').hide()
      return
    }

    let errorHtml = '<ul>'

    errors.forEach(e => {
      errorHtml += `<li>${e}</li>`
    })

    errorHtml += '</ul>'

    $('.c-errors').html(errorHtml).show()
  }

  getPriceFromCache (priceType) { 
    if ($body.hasClass('356172')) // Mask per-ticket price for Early Morning Tours
    {  
      return ' '
    }

  if (priceType == 676  || priceType == 677  || priceType == 678 || priceType == 679 || priceType == 741 || 
  priceType == 742 || priceType == 745  || priceType == 746 || priceType == 747 || priceType == 760 ) //Divide regular giving prices by 12
    {
      return pricingDataCache[priceType] ? '£' + pricingDataCache[priceType]/12 + ' per month' : ''
    }
      
      
    if ((pricingDataCache[priceType] === '0.00') || priceType == 154 || priceType == 155) {
      return 'Free'
    }
    return pricingDataCache[priceType] ? '£' + pricingDataCache[priceType] : ''
  }

  getComboPrice (priceType) {
    let totalPrice = 0

    priceType.forEach(type => {
      const priceString = pricingDataCache[type.type]
      if (priceString) {
        const priceFloat = parseFloat(priceString)
        totalPrice = totalPrice + (priceFloat * type.number)
      }
    })

    return `£${totalPrice.toFixed(2)}`
  }
}
